<template>
  <div>
    <el-row :gutter="15">
      <el-col :span="5">
        <el-card class="card">
          <div slot="header" class="card-header">
            <i class="el-icon-font el-icon-zuzhijigou el-icon--left"></i>组织
          </div>
          <div style="overflow: auto; height: calc(100vh - 179px)">
            <es-org-tree @clickByOrg="queryAccountList" :isAll="1" @completed="initOrgTree"></es-org-tree>
          </div>
        </el-card>
      </el-col>
      <el-col :span="19">
        <el-card class="card">
          <div slot="header" class="card-header">
            <i class="el-icon-font el-icon-yonghu el-icon--left"></i>人员
          </div>
          <div class="es-op-box">
            <el-input placeholder="请输入编码或姓名" v-model="queryObj.keyWord" size="small" class="query" style="float: left"
              clearable @change="
                () => {
                  this.queryObj.pageNum = 1;
                  loadAccountList();
                }
              ">
              <i slot="suffix" class="el-input__icon el-icon-search"></i>
            </el-input>
          </div>
          <el-table style="margin-top: 45px;" :data="pageData.list" ref="accountTable" border stripe size="mini" height="calc(100vh - 250px)"
            v-loading="loading">
            <el-table-column type="selection" width="40" align="center">
            </el-table-column>
            <el-table-column type="index" label="序号" width="50" align="center">
            </el-table-column>
            <el-table-column prop="loginNo" width="160" label="账号">
            </el-table-column>
            <el-table-column prop="userName" width="160" label="姓名">
            </el-table-column>
            <el-table-column prop="certiCount" label="证书数量"> </el-table-column>
            <el-table-column prop="cultiCount" label="培训次数">
            </el-table-column>
            <el-table-column label="操作" width="80" align="center">
              <template slot-scope="scope">
                <el-link :underline="false" title="人员证书" @click="add_certificate_tab(scope.row)" type="primary"><i
                    class="el-icon-notebook-2"></i></el-link>
                <el-divider direction="vertical"></el-divider>
                <el-link :underline="false" title="人员培训" @click="add_cultivate_tab(scope.row)" type="primary"><i
                    class="el-icon-notebook-1"></i></el-link>
              </template>
            </el-table-column>
          </el-table>
          <div class="es-page-box">
            <es-pagination :data="pageData" @change="
              (cpage) => {
                this.queryObj.pageNum = cpage;
                this.loadAccountList();
              }
            ">
            </es-pagination>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "usermanage",
  props: ["funcs"],
  data () {
    return {
      flag: false,
      orgTree: [],
      checkedKeys: [],
      queryObj: { pageNum: 1, pageSize: 20 }, //查询条件
      pageData: {},
      accountInfo: {}, //用户信息
      loading: false,
      saving: false,
    };
  },
  methods: {
    //页面初始化
    init () {
      this.loadAccountList();
    },
    initOrgTree (orgTree) {
      this.orgTree = orgTree;
    },
    queryAccountList (orgIds) {
      this.queryObj.pageNum = 1;
      if (orgIds != null && orgIds != []) {
        this.queryObj.orgIds = orgIds.join(",");
      }
      this.loadAccountList();
    },
    //从后台查询账户列表
    loadAccountList () {
      this.loading = true;
      this.$ajax
        .get("/base/userManage/list", this.queryObj)
        .then((msg) => {
          msg.list.forEach(item => {
            if (item.rolesName != null && item.rolesName.length > 0) {
              item.roleName = item.rolesName.toString()
            }
          })
          this.pageData = msg;
          this.loading = false;
        })
        .catch((err) => {
          this.$message.error(err);
          this.loading = false;
        });
    },
    //证书管理
    add_certificate_tab(row) {
        let param = {
          id: 11111,
          label: "证书管理",
          icon: "el-icon-yulanchakan",
          url: "/system/certimanage",
        };
        if (row != null) {
          param.paramId = row;
          
        }
        this.$emit("add-tab", param);
        
    },
    //培训管理
  add_cultivate_tab(row) {
        let param = {
          id: 11112,
          label: "培训管理",
          icon: "el-icon-yulanchakan",
          url: "/system/cultimanage",
        };
        if (row != null) {
          param.paramId = row;
          
        }
        this.$emit("add-tab", param);
        
    },
  },
  created () {
  },
  mounted () {
    this.init();
  },
};
</script>
<style scoped></style>
